export const FETCH_PRIVATEEXPOSUREASSETCHART_BEGIN = "FETCH_PRIVATEEXPOSUREASSETCHART_BEGIN";
export const FETCH_PRIVATEEXPOSUREASSETLEVELCHART_SUCCESS = "FETCH_PRIVATEEXPOSUREASSETLEVELCHART_SUCCESS";
export const FETCH_PRIVATEEXPOSUREASSETCHART_FAILURE = "FETCH_PRIVATEEXPOSUREASSETCHART_FAILURE";

export const FETCH_PRIVATEEXPOSURECATEGORYTYPEDATE_BEGIN = "FETCH_PRIVATEEXPOSURECATEGORYTYPEDATE_BEGIN";
export const FETCH_PRIVATEEXPOSURECATEGORYTYPEDATE_SUCCESS = "FETCH_PRIVATEEXPOSURECATEGORYTYPEDATE_SUCCESS";
export const FETCH_PRIVATEEXPOSURECATEGORYTYPEDATE_FAILURE = "FETCH_PRIVATEEXPOSURECATEGORYTYPEDATE_FAILURE";

